import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';

import { Button, Modal, Grid } from 'antd';

import { useSaveTerms } from 'v2/hooks/useSaveTerms';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const { useBreakpoint } = Grid;

export const ModalTerms = () => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [accesses] = useObservable(() => eduzzAccountsService.getAccesses(), []);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const saveAcceptTermsMutation = useSaveTerms({
    onSuccess: () => {
      toast.success('Aceite dos termos salvo com sucesso');
      setIsOpen(false);
    },
    onError: () => {
      toast.error('Erro ao aceitar os termos');
      setIsLoading(false);
    }
  });

  const saveRefuseTermosMutation = useSaveTerms({
    onSettled: () => {
      eduzzAccountsService.logout();
    }
  });

  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  useEffect(() => {
    if (!user || user.is_support || !accesses) return;
    const canApproveNewTerms = (accesses ?? []).some(
      item => item.id === user?.id && item.isMe === true && item.termsAcceptance == false
    );
    setIsOpen(canApproveNewTerms);
  }, [user, accesses]);

  const handleRefuse = async () => {
    setIsLoading(true);
    await saveRefuseTermosMutation.mutateAsync(false);
  };

  const handleAccept = async () => {
    setIsLoading(true);
    await saveAcceptTermsMutation.mutateAsync(true);
  };

  return (
    <Modal
      open={isOpen}
      zIndex={2000}
      width={isMobile ? '100vw' : 900}
      keyboard={false}
      closable={false}
      title='Atualizamos nossos Termos de Uso'
      footer={
        <div className='flex justify-end gap-2'>
          <Button disabled={isLoading} onClick={handleRefuse}>
            Recusar e sair
          </Button>
          <Button type='primary' disabled={isLoading} onClick={handleAccept}>
            Aceitar e prosseguir
          </Button>
        </div>
      }
    >
      <p className='mb-0!'>
        Estamos atualizando nossos Termos de Uso e, para continuar utilizando nossos serviços, a partir desta data você
        deve concordar com estas revisões.
      </p>
      <a
        href='https://eduzz.com/termos'
        target='_blank'
        rel='noopener noreferrer'
        className='my-5 flex justify-center text-blue-500'
      >
        Novos Termos de Uso da Eduzz
      </a>
      <p className='mb-0!'>Em caso de dúvidas entre em contato com o nosso Canal de Atendimento em:</p>
      <a href='mailto:suporte@eduzz.com' className='my-4 flex justify-center text-blue-500'>
        suporte@eduzz.com
      </a>
    </Modal>
  );
};
